import script from "./OutgoingEmailEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./OutgoingEmailEditor.vue?vue&type=script&setup=true&lang=js"

import "./OutgoingEmailEditor.vue?vue&type=style&index=0&id=52a8c1bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52a8c1bc"]])

export default __exports__